<template>
    <v-container fluid>
        <v-row class="px-8 pb-2 pt-1">
            <v-col cols="3" class="pr-4 pl-3">
                <v-btn depressed color="primary" @click="create">
                    <span>AJOUTER</span>
                </v-btn>
            </v-col>
            <v-col offset="6" cols="3" class="pt-0">
                <v-text-field
                        label="Titre"
                        hide-details
                        outlined
                        dense
                        @keydown="checkEnter"
                        v-model="searchByTitle"
                >
                    <template v-slot:append>
                        <v-btn
                                depressed
                                color="primary"
                                class="topBar-search ma-0"
                                @click="getNotificationByTitle"
                        >
                            <v-icon v-text="'fas fa-search'"></v-icon>
                        </v-btn>
                    </template>
                </v-text-field>
            </v-col>
        </v-row>
        <v-divider></v-divider>
        <TableDefault
                :headers="headers"
                :items="items"
                :totalPage="totalPage"
                :totalItem="totalItem"
                :limit="limit"
                :currentPage="currentPage"
                :content="content"
                @getContent="getContent"
                @edit="getNotificationEdit"
                @remove="remove"
                @changePage="changePage"
                @changeItemPerPage="changeItemPerPage"
        />
    </v-container>
</template>

<script>
    import TableDefault from "@/components/tables/TableDefault";
    import notificationService from "@/services/notification";
    import {mapState} from "vuex";

    export default {
        name: "Notification",
        components: { TableDefault },
        data: () => ({
            content: '',
            headers: [
                {
                    text: "ID",
                    field: "id",
                    width: "50px"
                },
                {
                    text: "Title",
                    field: "title",
                },
                {
                    text: "Active",
                    field: "active",
                    checkbox: true,
                    disable: true,
                    width: "50px"
                },
                {
                    text: "Action",
                    action: true,
                    hiddenEdit: false,
                    width: "130px"
                }
            ],
            items: [],
            totalPage: 1,
            totalItem: 0,
            currentPage: 1,
            limit: 50,
            searchByTitle: "",
        }),
        computed: {
            ...mapState({
                form: state => state.notification.notification
            })
        },
        created() {
            this.getNotification();
        },
        methods: {
            checkEnter(event) {
                if (event.code === "Enter") {
                    this.getNotification();
                }
            },
            changePage(page) {
                this.currentPage = page;
                this.getNotification();
            },
            changeItemPerPage(limit) {
                this.limit = limit;
                this.getNotification();
            },
            create() {
                this.$store.dispatch("resetNotification");
                this.$router.push({ name: "NotificationCreate" });
            },
            getNotificationByTitle() {
                this.currentPage = 1;
                this.getNotification();
            },
            async getNotification() {
                let res = await notificationService.getNotificationPagination({
                    limit: this.limit,
                    currentPage: this.currentPage,
                    searchByTitle: this.searchByTitle
                });
                if (res) {
                    this.items = res.data.data;
                    this.totalPage = res.data.totalPage;
                    this.totalItem = res.data.totalItem;
                }
            },
            async getContent(id) {
                this.content = '';
                let res = await notificationService.getDetail(id);
                if (res) {
                    this.content = res.data.content;
                }
            },
            async getNotificationEdit(notification) {
                let res = await notificationService.getDetail(notification.id);
                if (res) {
                    this.$store.dispatch("setNotification", res.data);
                    this.$router.push({
                        name: "NotificationEdit"
                    });
                }

            },
            async remove(notification) {
                await this.$store.dispatch("removeNotification", notification);
                this.getNotification();
            }
        },
    };
</script>
<style lang="sass">
    .v-menu__content
        .v-card
            margin: 0
        .radio-group .col
            padding: 0 12px
        .v-input--selection-controls .v-radio>.v-label
            color: #000
            font-weight: 400
        .v-input__icon
            height: 18px
</style>
